import React from 'react';
import CommonModal from '@components/common/CommonModal';
import RedInfoIcon from '../../../../assets/svg/exclamation.svg'
import ButtonModal from '@components/common/Button';
import { buttonNames } from '@constants/appConstants';
import { modalContent } from './DeathNotificationConstants';

interface DeathNotificationModalProps {
  setShowDeathNotification:any
  showModal: boolean;
  setShowDeathNotificationForm:any
}

const DeathNotificationModal: React.FC<DeathNotificationModalProps> = ({showModal, setShowDeathNotification, setShowDeathNotificationForm }) => {

  return (
    <CommonModal
      show={showModal}
      handleClose={()=>setShowDeathNotification(false)}
      handleCustomBackButton={()=>setShowDeathNotification(false)}
      conditionalClass="modal_component dynamic_form_field"
      showCustomHeader={true}
      title=""
      size="md"
      footer={
        <>
          <ButtonModal
            onClick={()=>setShowDeathNotificationForm(true)}
            id="cancel"
            buttonName={buttonNames.confirm}
            colorType={'secondary'}
          />
        </>
      }
    >
      <div className='hrp-warning-modal'>
        <div className='icon-class'><RedInfoIcon /></div>
        <h4 className='header-text'>{modalContent.headerText}</h4>
        <div className='warning-text'>{modalContent.bodyText}</div>
      </div>
    </CommonModal>
  );
};

export default DeathNotificationModal;
